/// <reference path="../../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class ModifyContractModalController {
        public static $inject: string[] = [
            '$mdMedia',
            '$mdDialog',
            '$dealerwareInternationalizationDateFormats',
            '$environmentNames',
            'Environment',
            'MicroFrontendOrigin',
        ];

        public contract: any;

        constructor(public $mdMedia: any,
                    public $mdDialog: any,
                    public $dealerwareInternationalizationDateFormats: any,
                    public $environmentNames: any,
                    public Environment: any,
                    public MicroFrontendOrigin: any) {}

        public get useFullScreen() {
            return (this.$mdMedia('xs') || this.$mdMedia('sm'));
        }

        public open() {
            var modifyContractController = this;

            function DialogController($scope: any,
                                      $mdDialog: any,
                                      $mobilityCompanyAuthentication: any,
                                      $dealerwareLoading: any,
                                      $dealerwareNotification: any,
                                      $dealerwareInternationalizationDateFormats: any,
                                      contract: any) {
                var time_zone = $mobilityCompanyAuthentication.location.time_zone_name;
                $scope.internationalization = $dealerwareInternationalizationDateFormats.datePickerFormat();

                $scope.modifyDialogController = modifyContractController;
                $scope.contract = contract;
                $scope.pickupDate = moment(contract.contractDetails.data.pickup).tz(time_zone).toDate();
                $scope.minPickupDate = moment().toDate();
                $scope.dropoffDate = moment(contract.contractDetails.data.dropoff).tz(time_zone).toDate();
                $scope.availableTimes = $dealerwareInternationalizationDateFormats.getAvailablesTimesFormat();

                $scope.cancel = function() : void {
                    $mdDialog.hide();
                };

                $scope.isValid = function() : boolean {
                    var contractData = $scope.contract.contractDetails.data;

                    return $scope.pickupDate.getTime() < $scope.dropoffDate.getTime() || (
                        $scope.pickupDate.getTime() === $scope.dropoffDate.getTime() &&
                        contractData.local_pickup_time < contractData.local_dropoff_time
                    );
                }

                $scope.canModify = function() : boolean {
                    return $scope.modifyContractForm.$dirty && $scope.isValid();
                }

                $scope.modifyContract = function() {
                    var data = $scope.contract.contractDetails.data,
                        loader = $dealerwareLoading.show('Saving...'),
                        successHandler = function() {
                            $scope.contract.loadContractDetails().finally(() => {
                                loader.close();
                                $mdDialog.hide();
                                $dealerwareNotification.toast('Contract modified!');
                            });
                        },
                        errorHandler = function(response: any) {
                            loader.close();
                            $dealerwareNotification.apiError(response);
                        }

                    data.local_pickup_date = moment($scope.pickupDate).format('YYYY-MM-DD');
                    data.local_dropoff_date = moment($scope.dropoffDate).format('YYYY-MM-DD');

                    if ($scope.contract.isStarted()) {
                        $scope.contract.contractDetails.$modifyStarted({
                            promise: true,
                            params: { location_id: $scope.contract.locationId }
                        }).then(successHandler, errorHandler);
                    } else {
                        $scope.contract.contractDetails.$modify({
                            promise: true,
                            params: { location_id: $scope.contract.locationId }
                        }).then(successHandler, errorHandler);
                    }
                }
            }

            const message = {
                actualPickup: this.contract.contractDetails.data.actual_pickup,
                contractId: this.contract.contractId,
                fleetId: this.contract.contractDetails.data.fleet_id,
                type: 'modifyContract',
            };
            window.parent.postMessage(message, this.MicroFrontendOrigin);
        }
    }

    getDealerwareWebComponentsModule().controller('ModifyContractModalController', ModifyContractModalController);


    export class ModifyContractModalDirective implements ng.IDirective {

        public restrict         : string    =   'A';
        public controller       : any       =   'ModifyContractModalController';
        public controllerAs     : string    =   'modifyContractModalController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   { contract: '=' };
        public transclude       : boolean   =   false;
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            elem    :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
            elem.bind('click', function() {
                    ctrls.open();
                }
            );
        }
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareModifyContractModal",() => new ModifyContractModalDirective());
}
